import {
  PropsWithChildren,
  createContext,
  useContext,
  useState,
  SetStateAction,
  Dispatch,
} from "react";
import { Media } from "types/qbank/media";

export type SessionDetailsModalOpen = {
  open: true;
  media: Media;
};
export type SessionDetailsModalClose = {
  open: false;
};

export type SessionDetailsModal =
  | SessionDetailsModalOpen
  | SessionDetailsModalClose;

export type SessionDetails = {
  username?: string;
  email?: string;
};

type IProps = PropsWithChildren<{}>;

const SessionDetailsContext = createContext<{
  sessionId: number;
  setSessionId: Dispatch<SetStateAction<number>>;
  sessionDetailsModal: SessionDetailsModal;
  setSessionDetailsModal: Dispatch<SetStateAction<SessionDetailsModal>>;
  sessionDetails: SessionDetails;
  setSessionDetails: Dispatch<SetStateAction<SessionDetails>>;
}>(undefined!);

export const SessionDetailsProvider = ({ children }: IProps) => {
  const [sessionId, setSessionId] = useState<number>(1);
  const [sessionDetailsModal, setSessionDetailsModal] =
    useState<SessionDetailsModal>({ open: false });
  const [sessionDetails, setSessionDetails] = useState<SessionDetails>({});

  return (
    <SessionDetailsContext.Provider
      value={{
        sessionId,
        setSessionId,
        sessionDetailsModal,
        setSessionDetailsModal,
        sessionDetails,
        setSessionDetails,
      }}
    >
      {children}
    </SessionDetailsContext.Provider>
  );
};

export const useSessionDetails = () => useContext(SessionDetailsContext);
